<template>
  <div id="TheLogo" class="logo-component">
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 566.9 220.7"><path :fill="fill" d="M0 0h566.9v220.7H0z"/><path fill="#FFF" d="M415.8 51.4h23.9l18 47.6h20.8V51.4h22.7V173h-43.5c-15.2 0-26.3-3.4-33.4-10.3-7.1-6.8-10.7-15.7-10.7-26.6 0-16.2 7.6-27.3 22.7-33.3l-20.5-51.4zm62.7 65.8h-17.2c-8.2 0-14.2 1.7-18.2 5.2-4 3.4-6 8.2-6 14.2 0 5.5 2 10 5.9 13.4 3.9 3.4 9.4 5.1 16.5 5.1h19v-37.9zM387.8 85.7c-.5-13-6.9-20.1-18.6-20.1-7.8 0-13 3-17.7 10.1L332 72.5c6.2-15.3 19.1-23.4 36.6-23.4 24.7 0 40.6 15.6 40.6 39.9 0 24.3-15.5 40.1-39.4 40.1-23.8 0-38.5-15.5-38.5-40.3v-3.1h56.5zM351.5 99c2.3 9.7 8.5 14.9 17.7 14.9 9.5 0 15.8-5.4 17.7-14.9h-35.4zM296.1 116.9c-7.5 8.5-14.9 12.2-24.8 12.2-20.8 0-36.8-17.2-36.8-39.8 0-23.1 15.8-40.3 37.2-40.3 10.2 0 17.7 3.6 24.5 12.2v-9.7h21v121.6h-21v-56.2zm-.5-27.8c0-11.6-9.6-21.2-21-21.2-11.8 0-21.2 9.4-21.2 21 0 11.8 9.4 21.2 21.2 21.2 11.6 0 21-9.3 21-21zM196.1 51.4h21v57h11.1v18.2h-11.1v25.7h-21v-25.7H185v-18.2h11.1v-57zM157.3 85.7c-.5-13-6.9-20.1-18.6-20.1-7.8 0-13 3-17.7 10.1l-19.4-3.1c6.2-15.3 19.1-23.4 36.6-23.4 24.7 0 40.6 15.6 40.6 39.9 0 24.3-15.5 40.1-39.4 40.1-23.8 0-38.5-15.5-38.5-40.3v-3.1h56.4zM121 99c2.3 9.7 8.5 14.9 17.7 14.9 9.5 0 15.8-5.4 17.7-14.9H121zM65.7 51.4h21V173h-21V51.4z"/></svg>
  </div>
</template>
<script>
export default {
  name: 'TheLogo',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: () => 118
    },
    height: {
      type: [Number, String],
      required: false,
      default: () => 47
    },
    fill: {
      type: String,
      required: false,
      default: () => '#E3232C'
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.logo-component {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TheLogo.vue